<template>
  <div class="common" :class="colorclass" @mouseover="show" @mouseout="hide">
    <div class="title">{{ title }}</div>
    <div class="category">
      <span
        :class="Index === index ? 'active' : ''"
        v-for="(item, index) of category"
        :key="item.id"
        @click="changeIndex(index)"
        >{{ item.cate_name }}</span
      >
    </div>
    <swiper class="swiper-box" :options="swiperOption" ref="Swiper">
      <swiper-slide v-for="item of product" :key="item.id">
        <div @click="goDetail(item.id)" class="swiper-content">
          <div class="product">
            <div class="product-title">{{ item.store_name }}</div>
            <!-- <div class="product-price">￥{{ item.price }}</div> -->
          </div>
          <div class="img">
            <img :src="item.image" alt="" />
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev left" slot="button-prev" ref="left"></div>
      <div
        class="swiper-button-next right"
        slot="button-next"
        ref="right"
      ></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "CategoryItem",
  props: ["product", "dataList", "category", "colorclass", "title"],
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // 循环
        loop: true,
        // 每张播放时长3秒，自动播放
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplayDisableOnInteraction: false,
        // 滑动速度
        speed: 1000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      },
      Index: 0
    };
  },
  computed: {
    swiper() {
      return this.$refs.Swiper.swiper;
    }
  },
  watch: {
    dataList() {
      if (
        this.dataList.cate_id &&
        Object.keys(this.dataList.cate_id).length > 0
      ) {
        this.getFirstVal(this.product, this.dataList);
      }
    }
  },
  mounted() {
    this.$refs.left.style.display = "none";
    this.$refs.right.style.display = "none";
  },
  methods: {
    // type为0代表初始化
    getFirstVal(product, dataList, type = 0) {
      let firstWord = String(dataList.cate_id[type].id);
      let tempVal = []; // 临时性存值
      dataList.product.forEach(element => {
        if (element.cate_id.split(",").includes(firstWord)) {
          tempVal.push(element);
        }
      });
      product.splice(0, tempVal.length);
      tempVal.forEach((item, index) => {
        product.splice(index, 1, item);
      });
    },
    changeIndex(index) {
      this.Index = index;
      this.getFirstVal(this.product, this.dataList, index);
    },
    show() {
      this.$refs.left.style.display = "block";
      this.$refs.right.style.display = "block";
    },
    hide() {
      this.$refs.left.style.display = "none";
      this.$refs.right.style.display = "none";
    },
    goDetail(id) {
      this.$router.push("/goodsDetail/" + id);
    }
  }
};
</script>

<style lang="stylus" scoped>
/deep/ .swiper-pagination-bullet
  width 10px
  height 10px
  &-active
    background rgba(255, 255, 255, 0)
    border 2px solid #fe5f41

// 公用方法
commonMethod($color)
  border-top 2px solid $color
  .title
    color $color
  .category
    color $color
    span
      &.active
        background $color
  .swiper-box
    .left
      &:after
        border-left 3px solid $color
        border-bottom 3px solid $color
    .right
      &:after
        border-left 3px solid $color
        border-bottom 3px solid $color

.common
  border-top 2px solid #fd7977
  width 280px
  height 450px
  background #fff
  &:hover
    box-shadow 0 0 10px #999
  .title
    margin-top 30px
    margin-bottom 20px
    font-size 18px
    text-align center
    color #fd7977
    font-weight 550
    letter-spacing 4px
  .category
    display flex
    flex-wrap wrap
    padding 0 14px
    color #fd7977
    height 46px
    span
      padding 0 8px
      font-size 13px
      line-height 24px
      height 24px
      cursor pointer
      &.active
        background #ff9492
        color #fff
  .swiper-box
    height 330px
    .swiper-content
      cursor pointer
      .product
        margin-top 5px
        margin-bottom 5px
        padding 0 10px
        &-title
          font-size 15px
          color #666
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
        &-price
          color #ff4638
          font-size 18px
          transform translateX(-3px)
      .img
        height 265px
        padding 0 10px
        text-align center
        line-height 420px
        img
          width 70%
          height 70%
    .left
      background rgba(255, 255, 255, 0)
      &:after
        content: ''
        display inline-block
        position absolute
        width 30px
        height 30px
        border-left 3px solid #fd7977
        border-bottom 3px solid #fd7977
        transform rotate(45deg)
        top 7px
        left 5px
    .right
      background rgba(255, 255, 255, 0)
      &:after
        content: ''
        display inline-block
        position absolute
        width 30px
        height 30px
        border-left 3px solid #fd7977
        border-bottom 3px solid #fd7977
        transform rotate(225deg)
        top 7px
        right 6px
.hot-list
  commonMethod(#ffc04a)
.new-product
  commonMethod(#69cb97)
.promotional-items
  commonMethod(#4f98df)
</style>
